import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import Services from './components/Services';
import Layout from './components/Layout';

function App() {
  return (
    <div className="App">
      <Layout />
      {/* <Services /> */}
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
    </div>
  );
}

export default App;
